import { render, staticRenderFns } from "./TemplateIndex.vue?vue&type=template&id=01826057"
import script from "./TemplateIndex.vue?vue&type=script&lang=js"
export * from "./TemplateIndex.vue?vue&type=script&lang=js"
import style0 from "./TemplateIndex.vue?vue&type=style&index=0&id=01826057&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports